// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-l_hf","advertDetailContacts__header":"c-l_hg"};